/**
 * @flow
 * @relayHash ab44ac8d11a6dafae3db1b26ed774b97
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type NoOfferOrderMutationInput = {|
  providerId: string,
  name: string,
  description: string,
  price: string,
  clientMutationId?: ?string,
|};
export type CreateOrderPageMutationVariables = {|
  input: NoOfferOrderMutationInput
|};
export type CreateOrderPageMutationResponse = {|
  +noOfferOrder: ?{|
    +order: ?{|
      +id: string
    |}
  |}
|};
export type CreateOrderPageMutation = {|
  variables: CreateOrderPageMutationVariables,
  response: CreateOrderPageMutationResponse,
|};
*/


/*
mutation CreateOrderPageMutation(
  $input: NoOfferOrderMutationInput!
) {
  noOfferOrder(input: $input) {
    order {
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "NoOfferOrderMutationInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "noOfferOrder",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "NoOfferOrderMutationPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "order",
        "storageKey": null,
        "args": null,
        "concreteType": "CustomerOrderNode",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CreateOrderPageMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "CreateOrderPageMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "CreateOrderPageMutation",
    "id": null,
    "text": "mutation CreateOrderPageMutation(\n  $input: NoOfferOrderMutationInput!\n) {\n  noOfferOrder(input: $input) {\n    order {\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd79ff6ddd7099987aeb21a92cc69ce0f';
module.exports = node;
